import { render } from "./RemoteUsersDetail.vue?vue&type=template&id=32fe9f3e&ts=true"
import script from "./RemoteUsersDetail.vue?vue&type=script&lang=ts"
export * from "./RemoteUsersDetail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__